import { ConditionalDisplay } from "$components/conditional-display";
import RHFTextField from "$components/rhf/text-field";
import { SelectField as RHFSelectField } from "$components/rhf-fields";
import { Grid } from "@material-ui/core";
import React from "react";
import { useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";
import {
  DEPENDENT,
  INSURER_DETAILS,
  INSURER_DETAILS_NAME,
  INSURERS,
  MEMBERSHIP_NUMBER,
  NATIONAL_ID_NUMBER,
  PRIVATE_INSURANCE,
} from "./formConstants";
import type { InsurerDetailsProps } from "./types";

export const InsurerDetails = ({
  index,
  insurerType,
  insurerProperties,
}: InsurerDetailsProps): React.ReactElement => {
  const { formatMessage } = useIntl();
  const { formState } = useFormContext();
  const { errors } = formState;

  const membershipNumberField = `${INSURERS}.${index}.${INSURER_DETAILS}.${MEMBERSHIP_NUMBER}`;
  const nationalIdNumberField = `${INSURERS}.${index}.${INSURER_DETAILS}.${NATIONAL_ID_NUMBER}`;
  const dependentField = `${INSURERS}.${index}.${INSURER_DETAILS}.${DEPENDENT}`;

  const privateInsuranceLabel = formatMessage({
    id: "insurerAccordion.details.privateInsuranceLabel",
    defaultMessage: "Insurance Name",
  });
  const insuranceNumberLabel = formatMessage({
    id: "insurerAccordion.details.insuranceNumberLabel",
    defaultMessage: "Membership Number",
  });
  const nationalIdNumberLabel = formatMessage({
    id: "insurerAccordion.details.nationalIdNumberLabel",
    defaultMessage: "National ID",
  });
  const dependantsLabel = formatMessage({
    id: "insurerAccordion.details.dependantsLabel",
    defaultMessage: "Dependants",
  });

  const renderOptions = (prop) =>
    prop?.enumTitles?.map((enumTitle, idx) => ({
      value: prop?.enum[idx],
      label: enumTitle,
    }));

  return (
    <Grid container spacing={2}>
      <ConditionalDisplay condition={insurerType === PRIVATE_INSURANCE}>
        <Grid item xs>
          <RHFTextField
            name={`${INSURERS}.${index}.${INSURER_DETAILS}.${INSURER_DETAILS_NAME}`}
            label={privateInsuranceLabel}
            fullWidth
          />
        </Grid>
      </ConditionalDisplay>
      {insurerProperties?.map((prop) => (
        <React.Fragment key={prop.name}>
          <ConditionalDisplay condition={prop.name === MEMBERSHIP_NUMBER}>
            <Grid item xs>
              <RHFTextField
                name={membershipNumberField}
                label={insuranceNumberLabel}
                fullWidth
              />
            </Grid>
          </ConditionalDisplay>
          <ConditionalDisplay condition={prop.name === NATIONAL_ID_NUMBER}>
            <Grid item xs>
              <RHFTextField
                name={nationalIdNumberField}
                label={nationalIdNumberLabel}
                fullWidth
              />
            </Grid>
          </ConditionalDisplay>
          <ConditionalDisplay condition={prop.name === DEPENDENT}>
            <Grid item xs>
              <RHFSelectField
                name={dependentField}
                label={dependantsLabel}
                options={renderOptions(prop)}
                fullWidth
              />
            </Grid>
          </ConditionalDisplay>
        </React.Fragment>
      ))}
    </Grid>
  );
};

export default InsurerDetails;
